<template>
    <div class="grid pb-0">
        <div class="grid-title-tab">
            <div class="d-grid-title">
                <h4>{{ $t("_BATCH_UPDATE.TITLE") }}</h4>
                <v-btn color="primary" @click="confirmUpdateSpecialPrice()" :loading="loading">
                    <template>{{ $t("UPDATE") }}</template>
                </v-btn>
            </div>
        </div>
        <div class="grid-body border-top-unset">
            <div class="pb-3">
                <div class="text-center" v-if="isLoading">
                    <img src="@/assets/loading-logo-animation.gif" style="width: 75px" />
                    <p class="font-weight-bold">{{ $t('THE_SYSTEM_IS_LOADING') }}</p>
                </div>
                <template v-else>
                    <div>
                        <div class="d-flex">
                            <div class="w-100 p-3 border-right">
                                <label class="pr-0 pb-3 font-weight-bold text-primary">
                                    {{ $t("FILTER") }}
                                </label>
                                <div class="d-flex w-100">
                                    <label class="pr-0"
                                        style="padding-top: 11px; margin-right: 12px; white-space: nowrap; min-width: 100px">
                                        {{ $t("SALE_PACKAGE") }}
                                    </label>
                                    <v-autocomplete item-text="text" item-value="value" :items="listPlans"
                                        v-model.lazy="plan_select" outlined dense>
                                        <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                        </template>
                                    </v-autocomplete>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <label class="pr-0"
                                        style="padding-top: 11px; margin-right: 12px; white-space: nowrap; min-width: 100px">
                                        {{ $t("ROOM_TYPE") }}
                                    </label>
                                    <v-autocomplete item-text="text" item-value="value" :items="listRooms"
                                        v-model="roomType_select" outlined chips dense multiple
                                        @change="$event => changeRoomSelect($event)">
                                        <template v-slot:prepend-item>
                                            <p class="mx-3 mt-1"> <a class="text-primary"
                                                    @click="roomType_select = listRooms.map(e => e.value)">{{
                                                        $t('SELECT_ALL') }}</a>
                                                | <a class="text-primary" @click="roomType_select = []">{{
                                                    $t('UN_SELECT_ALL') }}</a>
                                            </p>
                                        </template>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip color="primary" v-if="index === 0" v-bind="item.attrs"
                                                :input-value="item.selected" close
                                                @click:close="removeChips(index, roomType_select)" @click="item.select">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                                roomType_select.length - 1 }})</span>
                                        </template>
                                        <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </div>
                            <div class="w-100 p-3">
                                <label class="pr-0 pb-3 font-weight-bold text-primary">
                                    {{ $t("APPLY_FOR") }}
                                </label>
                                <div class="d-flex">
                                    <label class="pr-0"
                                        style="padding-top: 11px; margin-right: 12px; white-space: nowrap; min-width: 100px">
                                        {{ $t("_HOTEL_CHAIN.CHAIN_LIST_HOTEL") }} *
                                    </label>
                                    <v-autocomplete item-text="text" item-value="value" :items="listHotel"
                                        :class="hotel_select.length === 0 ? 'border-danger-text' : ''"
                                        v-model="hotel_select" outlined chips dense multiple>
                                        <template v-slot:prepend-item>
                                            <p class="mx-3 mt-1"> <a class="text-primary"
                                                    @click="hotel_select = listHotel.map(e => e.value)">{{
                                                        $t('SELECT_ALL') }}</a>
                                                | <a class="text-primary" @click="hotel_select = []">{{
                                                    $t('UN_SELECT_ALL') }}</a>
                                            </p>
                                        </template>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
                                                :input-value="item.selected" close
                                                @click:close="removeChips(index, hotel_select)" @click="item.select">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                            <span v-if="index === 2" class="grey--text caption">(+{{
                                                hotel_select.length - 2 }})</span>
                                        </template>
                                        <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                        </template>
                                    </v-autocomplete>
                                </div>
                                <div class="d-flex w-100 mt-2">
                                    <label class="pr-0"
                                        style="padding-top: 11px; margin-right: 12px; white-space: nowrap; min-width: 100px">
                                        {{ $t("SALE_CHANNEL") }} *
                                    </label>
                                    <v-autocomplete item-text="text" item-value="value" :items="listOtas" required
                                        :class="ota_select.length === 0 ? 'border-danger-text' : ''" v-model="ota_select"
                                        outlined chips dense multiple>
                                        <template v-slot:prepend-item>
                                            <p class="mx-3 mt-1"> <a class="text-primary"
                                                    @click="ota_select = listOtas.map(e => e.value)">{{
                                                        $t('SELECT_ALL') }}</a>
                                                | <a class="text-primary" @click="ota_select = []">{{ $t('UN_SELECT_ALL')
                                                }}</a>
                                            </p>
                                        </template>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
                                                :input-value="item.selected" close
                                                @click:close="removeChips(index, ota_select)" @click="item.select">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                            <span v-if="index === 2" class="grey--text caption">(+{{
                                                ota_select.length - 2 }})</span>
                                        </template>
                                        <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </div>
                        </div>
                        <div class="config-price">
                            <template>
                                <div class="w-100">
                                    <div class="d-sticky h-header-table d-flex">
                                        <div class="mr-auto">

                                        </div>
                                        <div>
                                            <div class="small-gutters d-flex">
                                                <div class="text-center font-weight-bold"
                                                    :style="item.code === 'MON' ? 'width: 112px' : 'width: 94px'"
                                                    v-for="item in daysOfWeek">{{ item.value }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <template
                                        v-for="(room, roomIndex) in rooms.filter(item => roomType_select.includes(item.roomTypeId))">
                                        <div class="px-3 pt-2">
                                            <div>
                                                <b-row class="mb-1">
                                                    <v-col md="6" class="pb-0 pt-1">
                                                        <div class="d-flex align-center h-100 text-primary">
                                                            <span class="font-weight-bold text-primary pr-2">
                                                                {{ room.name
                                                                }}
                                                            </span>
                                                            -
                                                            <span class="font-weight-bold text-primary pl-2">
                                                                {{
                                                                    planName
                                                                }}
                                                            </span>
                                                        </div>
                                                    </v-col>
                                                </b-row>
                                                <template v-for="(date, indDate) in room.dates">
                                                    <div class="d-flex mb-2">
                                                        <div class="pb-0 d-date mr-auto">
                                                            <template v-if="roomIndex === 0">
                                                                <div class="d-flex align-items-center">
                                                                    <date-picker :disabled-date="notBeforeToday"
                                                                        @input="changDate(room)" :confirm="true"
                                                                        :confirm-text="$t('CONFIRM')" :clearable="false"
                                                                        :popup-class="'popup-calendar-desktop-detailhotel'"
                                                                        v-model="date.dateSelect" :lang="languageDate"
                                                                        :format="'DD/MM/YYYY'" :shortcuts="[]" range
                                                                        placeholder="Select date range">
                                                                    </date-picker>
                                                                    <v-btn v-if="room.dates.length > 1" color="red"
                                                                        @click="removePeriodSpecialPrice(indDate)"
                                                                        class="ml-1" icon small><i
                                                                            class="icon-delete fs-16"></i></v-btn>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                                                                {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                                                            </template>
                                                        </div>
                                                        <div>
                                                            <div class="small-gutters">
                                                                <div class="pb-0 pt-0 d-flex align-items-center">
                                                                    <v-btn color="primary" @click="copyPrice(date)"
                                                                        :title="$t('COPY')" icon small><i
                                                                            class="icon-content_paste_go fs-16"></i></v-btn>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['MON'].disable"
                                                                        v-model.lazy="date['MON'].value" />
                                                                </div>
                                                                <div>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['TUE'].disable"
                                                                        v-model.lazy="date['TUE'].value" />
                                                                </div>
                                                                <div>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['WED'].disable"
                                                                        v-model.lazy="date['WED'].value" />
                                                                </div>
                                                                <div>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['THU'].disable"
                                                                        v-model.lazy="date['THU'].value" />
                                                                </div>
                                                                <div>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['FRI'].disable"
                                                                        v-model.lazy="date['FRI'].value" />
                                                                </div>
                                                                <div>
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['SAT'].disable"
                                                                        v-model.lazy="date['SAT'].value" />
                                                                </div>
                                                                <div class="mr-0">
                                                                    <currency-ptd
                                                                        :classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
                                                                        :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn
                                                                            " :disabled="date['SUN'].disable"
                                                                        v-model.lazy="date['SUN'].value" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <v-row class="mt-0" v-if="roomIndex === 0">
                                                    <v-col class="pt-0 pb-0">
                                                        <v-btn color="primary" outlined x-small
                                                            @click="addDatePriodSpecialPrice(room)">
                                                            <i class="icon-add fs-14"></i>
                                                            <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                        <hr class="mb-0" />
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>

                <div class="text-right pt-3 px-3" v-if="!isLoading">
                    <v-btn color="primary" @click="confirmUpdateSpecialPrice()" :loading="loading">
                        <template>{{ $t("UPDATE") }}</template>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import "vue2-datepicker/index.css";
import { chainService } from "@/_services/ChainManage/chain.service.js";
export default {
    components: {
        "date-picker": () => import('vue2-datepicker'),
        "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
    },
    data() {
        return {
            currency: JSON.parse(localStorage.getItem("currency")),
            listRooms: [],
            currentDate: moment()
                .startOf("day")
                .toDate(),
            systemLang: this.$i18n.locale,

            listPlans: [],
            plan_select: null,
            listOtas: [],
            isLoading: true,

            listHotel: [],
            hotel_select: [],
            roomType_select: [],
            daysOfWeek: [
                { code: "MON", value: this.$t("MONDAY") },
                { code: "TUE", value: this.$t("TUESDAY") },
                { code: "WED", value: this.$t("WEDNESDAY") },
                { code: "THU", value: this.$t("THURSDAY") },
                { code: "FRI", value: this.$t("FRIDAY") },
                { code: "SAT", value: this.$t("SATURDAY") },
                { code: "SUN", value: this.$t("SUNDAY") }
            ],
            rooms: [],
            loading: false,
            ota_select: []
        };
    },
    computed: {
        planName() {
            return this.listPlans.find(e => e.value === this.plan_select).text
        }
    },
    created() {
        this.currency = this.priceOptionsVi.suffix;
        this.initialize();
    },
    watch: {
        rooms: {
            handler(val) {
                val.forEach(room => {
                    room.dates.forEach(date => {
                        var start = moment(date.dateSelect[0], "YYYY-MM-DD");
                        var end = moment(date.dateSelect[1], "YYYY-MM-DD");

                        // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
                        let day = moment.duration(end.diff(start)).asDays();

                        // Reset lại toàn bộ
                        if (day < 6) {
                            while (start <= end) {
                                let daysOfWeek = this.formatDateOfWeek(start);
                                // Mở các thứ ở trong khoảng
                                date[daysOfWeek].disable = false;
                                start = moment(start).add(1, "day");
                            }
                        } else {
                            // Nếu khoảng ngày trải dài cả tuần thì mở hết.
                            date.MON.disable = false;
                            date.TUE.disable = false;
                            date.WED.disable = false;
                            date.THU.disable = false;
                            date.FRI.disable = false;
                            date.SAT.disable = false;
                            date.SUN.disable = false;
                        }
                    });
                })

            },
            deep: true
        },
    },
    methods: {
        initialize() {
            this.plan_select = this.$route.params.id;
            this.getHotelByChain();
        },
        async getHotelByChain() {
            await chainService.getHotelByChain(this.defaultI18n).then((res) => {
                if (res.responseCode == 0) {
                    this.listHotel = res.data.map((x) => {
                        return {
                            value: x.id,
                            text: x.name,
                        };
                    });
                    this.hotel_select = this.listHotel.map(e => e.value);
                }
            }).finally(() => (this.getAllRooms()));
        },
        getAllRooms() {
            let body = {};
            body.keyword = '';
            body.status = 1;
            body.limit = 99999;
            body.offset = 0;
            body.orderBy = 'active';
            body.asc = false;
            chainService.getAllRooms(body).then(res => {
                this.listRooms = res.data.map(x => {
                    return {
                        value: x.roomId,
                        text: x.i18ns.find(y => y.lang == this.defaultI18n).name
                    };
                });
                let from = moment(new Date())
                    .format("YYYY-MM-DD");
                let to = moment(new Date())
                    .add(1, "day")
                    .format("YYYY-MM-DD");
                this.rooms = this.listRooms.map(e => Object.assign({}, {
                    roomTypeId: e.value,
                    ratePlanId: null,
                    name: e.text,
                    dates: [{
                        dateSelect: [new Date(from), new Date(to)],
                        MON: {
                            value: null,
                            disable: true
                        },
                        TUE: {
                            value: null,
                            disable: true
                        },
                        WED: {
                            value: null,
                            disable: true
                        },
                        THU: {
                            value: null,
                            disable: true
                        },
                        FRI: {
                            value: null,
                            disable: true
                        },
                        SAT: {
                            value: null,
                            disable: true
                        },
                        SUN: {
                            value: null,
                            disable: true
                        }
                    }]
                }))
                this.roomType_select = this.listRooms.map(e => e.value)
            }).finally(() => (this.getAllRatePlanChain()));
        },
        getAllRatePlanChain() {
            let body = {};
            body.keyword = '';
            body.status = 1;
            body.limit = 99999;
            body.offset = 0;
            body.orderBy = 'active';
            body.asc = false;
            chainService
                .getAllRatePlanChain(body)
                .then(res => {
                    this.listPlans = res.data.map(x => {
                        return {
                            value: x.id,
                            text: x.i18ns.find(y => y.lang == this.defaultI18n).name
                        };
                    });
                }).finally(() => (this.getAllOtaChain()));
        },
        getAllOtaChain() {
            chainService
                .getAllOtaChain()
                .then(res => {
                    this.listOtas = res.data.map(x => {
                        return {
                            value: x.id,
                            text: x.i18ns.find(y => y.lang == this.defaultI18n).name
                        };
                    });
                    this.ota_select = this.listOtas.map(e => e.value);
                }).finally(() => (this.isLoading = false));
        },
        addDatePriodSpecialPrice(room) {
            var prevPeriod = null;
            if (room.dates.length > 0) {
                prevPeriod = room.dates[
                    room.dates
                        .length - 1
                ];
                const tomorrow = new Date();
                tomorrow.setDate(new Date().getDate() + 365 * 2);
                if (
                    new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >=
                    tomorrow
                ) {
                    return;
                }
                let from = moment(prevPeriod.dateSelect[1])
                    .add(1, "day")
                    .format("YYYY-MM-DD");
                let to = moment(prevPeriod.dateSelect[1])
                    .add(2, "day")
                    .format("YYYY-MM-DD");
                this.rooms.forEach(room => {
                    room.dates.push({
                        dateSelect: [new Date(from), new Date(to)],
                        MON: {
                            value: null,
                            disable: true
                        },
                        TUE: {
                            value: null,
                            disable: true
                        },
                        WED: {
                            value: null,
                            disable: true
                        },
                        THU: {
                            value: null,
                            disable: true
                        },
                        FRI: {
                            value: null,
                            disable: true
                        },
                        SAT: {
                            value: null,
                            disable: true
                        },
                        SUN: {
                            value: null,
                            disable: true
                        }
                    });
                });
            } else {
                let from = moment(new Date())
                    .add(1, "day")
                    .format("YYYY-MM-DD");
                let to = moment(new Date())
                    .add(2, "day")
                    .format("YYYY-MM-DD");
                this.rooms.forEach(room => {
                    room.dates.push({
                        dateSelect: [new Date(from), new Date(to)],
                        MON: {
                            value: null,
                            disable: true
                        },
                        TUE: {
                            value: null,
                            disable: true
                        },
                        WED: {
                            value: null,
                            disable: true
                        },
                        THU: {
                            value: null,
                            disable: true
                        },
                        FRI: {
                            value: null,
                            disable: true
                        },
                        SAT: {
                            value: null,
                            disable: true
                        },
                        SUN: {
                            value: null,
                            disable: true
                        }
                    });
                });
            }
        },
        removePeriodSpecialPrice(index) {
            this.rooms.forEach(room => {
                room.dates.splice(index, 1);
            });

        },
        changDate(r) {
            let arrDate = [];
            r.dates.forEach(element => {
                arrDate.push(element.dateSelect);
            });
            this.rooms.forEach(room => {
                room.dates.forEach((date, index) => {
                    date.MON.disable = true;
                    date.TUE.disable = true;
                    date.WED.disable = true;
                    date.THU.disable = true;
                    date.FRI.disable = true;
                    date.SAT.disable = true;
                    date.SUN.disable = true;
                    date.dateSelect = arrDate[index];
                });
            });
        },
        copyPrice(date) {
            var value = null;
            if (!date.MON.disable) {
                value = date.MON.value;
            } else if (!date.TUE.disable) {
                value = date.TUE.value;
            } else if (!date.WED.disable) {
                value = date.WED.value;
            } else if (!date.THU.disable) {
                value = date.THU.value;
            } else if (!date.FRI.disable) {
                value = date.FRI.value;
            } else if (!date.SAT.disable) {
                value = date.SAT.value;
            } else if (!date.SUN.disable) {
                value = date.SUN.value;
            }
            date.MON.value = !date.MON.disable ? value : null;
            date.TUE.value = !date.TUE.disable ? value : null;
            date.WED.value = !date.WED.disable ? value : null;
            date.THU.value = !date.THU.disable ? value : null;
            date.FRI.value = !date.FRI.disable ? value : null;
            date.SAT.value = !date.SAT.disable ? value : null;
            date.SUN.value = !date.SUN.disable ? value : null;
        },

        async confirmUpdateSpecialPrice() {
            this.loading = true;
            if (this.hotel_select.length === 0 || this.roomType_select.length === 0 || this.ota_select.length === 0) {
                this.loading = false;
                return
            }
            const dates = [];
            let arrDate = [];
            this.rooms.filter(item => this.roomType_select.includes(item.roomTypeId))[0].dates.forEach(
                date => {
                    arrDate.push(date.dateSelect);
                }
            );
            arrDate.forEach((date) => {
                if (this.get_day_of_time(new Date(date[0]), new Date(date[1])) > 365) {
                    _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
                    check = true;
                    return true;
                }
                let fromDate = moment(date[0], "YYYY-MM-DD");
                let toDate = moment(date[1], "YYYY-MM-DD");
                while (fromDate <= toDate) {
                    dates.push(fromDate.format("YYYY-MM-DD"));
                    fromDate = moment(fromDate).add(1, "day");
                }
            });
            if (dates.filter((item, index) => dates.indexOf(item) !== index).length > 0) {
                _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
                this.loading = false;
                return;
            }
            const body = {
                hotelIds: [...this.hotel_select],
                otaIds: [...this.ota_select],
                roomRates: []
            };
            const arrRooms = JSON.parse(JSON.stringify(this.rooms.filter(item => this.roomType_select.includes(item.roomTypeId))));
            arrRooms.forEach(room => {
                var dateValue = [];
                room.dates.forEach(date => {
                    let fromDate = moment(date.dateSelect[0], "YYYY/MM/DD");
                    let toDate = moment(date.dateSelect[1], "YYYY/MM/DD");
                    while (fromDate <= toDate) {
                        let daysOfWeek = this.formatDateOfWeek(fromDate);

                        if (
                            date[daysOfWeek].value != null &&
                            date[daysOfWeek].value != "0"
                        ) {
                            dateValue.push({
                                apply: fromDate.format("YYYY-MM-DD"),
                                value: date[daysOfWeek].value
                            });
                        }
                        fromDate = moment(fromDate).add(1, "day");
                    }
                });
                if (dateValue.length > 0) {
                    body.roomRates.push({
                        roomTypeId: room.roomTypeId,
                        ratePlanId: this.plan_select,
                        dates: [...dateValue]
                    })
                }

            });
            await chainService
                .updateRateOta(body)
                .then(res => {
                    _alert(res, this.$t(res.data), false);
                    if (res.responseCode === 0) {
                        this.$router.push({ name: 'chain-rate-plan' })
                    }

                }).finally(() => (this.loading = false));
        },
        formatDateOfWeek(date) {
            let dayOfWeek;
            switch (date.day()) {
                case 0: {
                    dayOfWeek = "SUN";
                    break;
                }
                case 1: {
                    dayOfWeek = "MON";
                    break;
                }
                case 2: {
                    dayOfWeek = "TUE";
                    break;
                }
                case 3: {
                    dayOfWeek = "WED";
                    break;
                }
                case 4: {
                    dayOfWeek = "THU";
                    break;
                }
                case 5: {
                    dayOfWeek = "FRI";
                    break;
                }
                case 6: {
                    dayOfWeek = "SAT";
                    break;
                }
            }
            return dayOfWeek;
        },
        _moment: moment
    }
};
</script>